import * as i0 from '@angular/core';
import { Injectable, Component, Directive, ElementRef, NgModule } from '@angular/core';
import { iframeResizer } from 'iframe-resizer';

import * as ɵngcc0 from '@angular/core';
class IframeResizerService {
    constructor() { }
}
IframeResizerService.ɵfac = function IframeResizerService_Factory(t) { return new (t || IframeResizerService)(); };
IframeResizerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function IframeResizerService_Factory() { return new IframeResizerService(); }, token: IframeResizerService, providedIn: "root" });
IframeResizerService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IframeResizerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class IframeResizerComponent {
    constructor() {
    }
    ngOnInit() {
        // console.log('iframe', iframeResize);
    }
}
IframeResizerComponent.ɵfac = function IframeResizerComponent_Factory(t) { return new (t || IframeResizerComponent)(); };
IframeResizerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: IframeResizerComponent, selectors: [["lib-iframe-resizer"]], decls: 2, vars: 0, template: function IframeResizerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, " iframe-resizer works! ");
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
IframeResizerComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IframeResizerComponent, [{
        type: Component,
        args: [{
                selector: 'lib-iframe-resizer',
                template: `
    <p>
      iframe-resizer works!
    </p>
  `
            }]
    }], function () { return []; }, null); })();

class IFrameResizerDirective {
    constructor(element) {
        this.element = element;
    }
    ngAfterViewInit() {
        const components = iframeResizer({
            checkOrigin: false,
            heightCalculationMethod: 'documentElementOffset',
            log: false
        }, this.element.nativeElement);
        this.component = components && components.length > 0 ? components[0] : null;
    }
    ngOnDestroy() {
        if (this.component && this.component.iFrameResizer) {
            this.component.iFrameResizer.close();
        }
    }
}
IFrameResizerDirective.ɵfac = function IFrameResizerDirective_Factory(t) { return new (t || IFrameResizerDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
IFrameResizerDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: IFrameResizerDirective, selectors: [["", "iframeResizer", ""]] });
IFrameResizerDirective.ctorParameters = () => [
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IFrameResizerDirective, [{
        type: Directive,
        args: [{
                selector: '[iframeResizer]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();

// @ts-ignore
class IframeResizerModule {
}
IframeResizerModule.ɵfac = function IframeResizerModule_Factory(t) { return new (t || IframeResizerModule)(); };
IframeResizerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: IframeResizerModule });
IframeResizerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IframeResizerModule, [{
        type: NgModule,
        args: [{
                declarations: [IframeResizerComponent, IFrameResizerDirective],
                imports: [],
                exports: [IframeResizerComponent, IFrameResizerDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(IframeResizerModule, { declarations: [IframeResizerComponent, IFrameResizerDirective], exports: [IframeResizerComponent, IFrameResizerDirective] }); })();

/*
 * Public API Surface of iframe-resizer
 */

/**
 * Generated bundle index. Do not edit.
 */

export { IFrameResizerDirective, IframeResizerComponent, IframeResizerModule, IframeResizerService };

